export const countries = {
    // European countries
    ES: 'Spain',
    PT: 'Portugal',
    FR: 'France',
    IT: 'Italy',
    DE: 'Germany',
    GB: 'United Kingdom',
    UK: 'United Kingdom',
    NL: 'Netherlands',
    BE: 'Belgium',
    AT: 'Austria',
    CH: 'Switzerland',
    SE: 'Sweden',
    NO: 'Norway',
    DK: 'Denmark',
    FI: 'Finland',
    IE: 'Ireland',
    PL: 'Poland',
    CZ: 'Czech Republic',
    HU: 'Hungary',
    RO: 'Romania',
    BG: 'Bulgaria',
    HR: 'Croatia',
    SI: 'Slovenia',
    SK: 'Slovakia',
    LT: 'Lithuania',
    LV: 'Latvia',
    EE: 'Estonia',
    GR: 'Greece',
    CY: 'Cyprus',
    MT: 'Malta',
    LU: 'Luxembourg',

    // American countries
    US: 'United States',
    CA: 'Canada',
    MX: 'Mexico',
    BR: 'Brazil',
    AR: 'Argentina',
    CL: 'Chile',
    CO: 'Colombia',
    PE: 'Peru',
    VE: 'Venezuela',
    EC: 'Ecuador',
    BO: 'Bolivia',
    UY: 'Uruguay',
    PY: 'Paraguay',

    // Other common countries
    CN: 'China',
    JP: 'Japan',
    KR: 'South Korea',
    IN: 'India',
    AU: 'Australia',
    NZ: 'New Zealand',
    ZA: 'South Africa',
    EG: 'Egypt',
    MA: 'Morocco',
    NG: 'Nigeria',

    // Fallback for unknown codes
    UNKNOWN: 'Unknown Country'
}; 